export const blogList = [
  {
    id: 1,
    title: 'Physics',
    category: 'development',
    subCategory: ['learn', 'develpement', 'mind growth','concepts'],
    url:"https://raw.githubusercontent.com/CodeNinjaUsman/React-markdown-Blog/main/src/config/physics.md",
    authorName: 'Muhammad Usman',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: 'https://img.freepik.com/free-vector/hand-drawn-scientific-formulas-chalkboard_23-2148495302.jpg',
  },
  {
    id: 2,
    title: 'Biology',
    category: 'travel',
    subCategory: ['vacation', 'holidays', 'sight seeing'],
    url:"https://raw.githubusercontent.com/CodeNinjaUsman/ChatingSpace/main/studuybud-real/StudyBud/README.md",
    authorName: 'Muhammad Usman',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: 'https://img.freepik.com/free-vector/hand-drawn-science-education-background_23-2148499315.jpg',
  },
  {
    id: 3,
    title: 'Chemistry',
    category: 'shopping',
    subCategory: ['e-commerce store', 'clothing', 'shopping store'],
    url:
      "https://raw.githubusercontent.com/CodeNinjaUsman/ChatingSpace/main/studuybud-real/StudyBud/README.md",
    authorName: 'Muhammad Usman',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'June 03, 2021',
    cover: 'https://c4.wallpaperflare.com/wallpaper/922/313/191/abstract-abstraction-biology-chemistry-wallpaper-preview.jpg',
  },
];
